export default {
    roles: {
        admin: 'Admin',
        owner: 'Owner',
        member: 'Member',
        developer: 'Developer',
        agent: 'Agent',
        sales: 'Sales',
    },
    status: {
        active: 'Active',
        pending: 'Pending',
        inactive: 'Inactive',
    },
    filters: {
        search: 'Search by name',
        status: 'Status',
        role: 'Role',
    },
    headers: {
        name: 'Name',
        description: 'Description',
        'date-added': 'Date added',
        email: 'Email',
        title: 'Title',
        status: 'Status',
        role: 'Role',
        actions: 'Actions',
        'table-permissions': 'Table permissions',
        'workflow-permissions': 'Workflow permissions',
        'last-invitation-sent': 'Last invitation sent',
        'last-sign-in': 'Last sign in',
    },
    invite: {
        title: 'Invite new member',
        name: 'Name',
        surname: 'Surname',
        email: 'Email',
    },
    edit: {
        title: 'Edit member profile',
        'organization-info': 'Changes will only apply to your profile in this organization.',
        'success-notification': 'Profile has been updated successfully!',
    },
    invitations: {
        title: 'Invitations',
    },
    actions: {
        reinvite: 'Re-invite',
        manage: 'Manage',
        block: 'Block',
        activate: 'Activate',
    },
    membership: {
        'add-member': 'Add new member',
    },
    'success-notification': 'The invitation has been sent to {email}!',
    'configure-roles': {
        title: 'Manage roles',
        'add-new': 'Add new role',
        search: 'Search by name',
        groups: {
            definition: 'Definition',
            data: 'Data',
            attachments: 'Attachments',
            comment: 'Comments',
            workflow: 'Definition',
        },
        levels: {
            edit: 'Edit',
            read: 'Read',
            none: 'None',
            inherit: 'Inherit',
            comment: 'Comment',
            run: 'Run',
        },
    },
    'add-user-hint': {
        label: 'How to add a user?',
        tooltip: 'To add a user, go to the "Organization" page from the user menu in the lower-left corner of the screen',
    },
}
